import { parse, format } from 'date-fns';
export const ignoreGroup = (str: any) => {
  return str?.replace('(Group)', ' ')?.trim();
};

export function formatPatientData(
  floorNumber?: any | null,
  roomNumber?: any | null,
  bedAssignment?: any | null
): string {
  const values = [floorNumber, roomNumber, bedAssignment]?.filter((value) => value);

  if (values?.length === 0) {
    return 'N/A';
  }

  return values?.join('-');
}

const partA = ['MEDICARE_A'];
const partB = ['MEDICARE_B', 'MANAGED_CARE_B', 'MANAGED_CARE_PART_B'];
const medicaid = ['MEDICAID'];
const other = ['OTHER', 'COMMERCIAL_INSURANCE', 'PRIVATE_PAY', 'HOSPICE', 'VA', 'MANAGED_CARE_A'];

export const getPayerCateGroup = (currentType: string) => {
  if (partA.includes(currentType)) {
    return { borderColor: '#76CE82', bgColor: '#76CE8226' };
  }
  if (partB.includes(currentType)) {
    return { borderColor: '#FFC700', bgColor: '#FFC70026' };
  }
  if (medicaid.includes(currentType)) {
    return { borderColor: '#FF7262', bgColor: '#FF726226' };
  }
  if (other.includes(currentType)) {
    return { borderColor: '#0A9ECC', bgColor: '#0A9ECC26' };
  }
};

export const getSameDateIgnoringTimezone = (dateOfService: any) => {
  const parsedDate = parse(dateOfService, 'yyyy-MM-dd', new Date());
  return parsedDate;
};


export const fetchAndLogPublicIP = async () => {
  try {
    const response = await fetch('https://api64.ipify.org?format=json');

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const ipJson = await response.json();
    return ipJson.ip; // Return the IP if needed
  } catch (error) {
    console.error('Could not retrieve IP address:', error);
  }
};